<template>
  <div >
          <div class="header-resultado">
        <div class="metade">
            Data	
        </div>
        <div class="metade">
            Optante	
        </div>
        <div class="metade">
            Produtos Válidas	
        </div>
        <div class="metade">
            Produtos Inválidas	
        </div>
        <div class="metade" style="border: none;">
            Total de Produtos	
        </div>
    </div>  
    <div class="ronaldo">    
    <div v-for="(n,i) in dados.consultas" :key="i" style="margin-bottom:12px;">
        <div class="body-resultado" @click="logs(n.id, n.optante)">
            <div class="metade" style="color:#393842;font-weight:bold">    
                {{n.data}}        
            </div>
            <div  class="metade" >  
                {{n.optante ? 'Sim' : 'Não'}}            
            </div>
            <div  class="metade"> 
                {{n.validas}}           
            </div>
            <div  class="metade" >  
                {{n.invalidas}}            
            </div>            
            <div class="metade" style="border: none;">{{n.invalidas+n.validas}}   </div>
        </div>
    </div>
    </div>      
 
  </div>
</template>

<script>
import axios from 'axios'
export default {
   data(){
        return{
            dados:[]
        }
    },
    methods:{  
        logs(idConsulta,optante){
            this.$emit('receberAtual',1)
            this.$store.state.optante = optante
            this.$router.push({name:'op',params:{id:1,isConsulta:idConsulta}})
            
        },
        async getConsultas(){
            await axios.get(`https://www.lefisc.com.br/api/revisor/cliente/logs/`)
            .then(result=>{
                this.dados = result.data              
                for(let d of this.dados.consultas){
                    let d10 = d.data.substring(0,10).split('-')
                    d10 = d10[2]+'/'+d10[1]+'/'+d10[0]+ " " + d.data.substring(11,16)
                    d.data = d10
                }
            })
            .catch(_=>console.log(_))
        }   
    },
    created(){
        this.getConsultas()
    }
}
</script>

<style>
.blocoImagem img{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 149px;    
    width: 270px;
}
.blocoImagem{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    text-align: justify;    
    border: 1px solid #4A154B;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    border-radius: 10px;
    margin-top: 10px;    
    cursor: pointer;
    align-items: flex-start;
}
.collapsaee{
  display: inherit !important;
}
.abrir{
    display: none;  
 
}
.txtFed{
    color:#4A154B;
    font-weight: bold;
    cursor: pointer;    
    border-bottom: 1px solid #000000;
    padding-bottom: 7px;
    padding: 0px 30px;
    font-size: 1.1em;
}
@media screen and (max-width: 900px) {
.blocoImagem img{   
    width: 100%;
}
}
</style>